import React from 'react';
import styled from 'styled-components';
import { spacer40, makeColorSetClass, cssColorValue, spacer24, spacer48, screenMdMax, spacer32, spacer72, spacer16, spacer56, KeyboardDetectionProvider, } from '@spotify-internal/encore-web';
import { TwoUpSegmentText, TwoUpSegmentMedia } from './TwoUpSegment';
import { ContentfulImage, Grid, ImageAspectBox21x9, ONE_COLUMN_MAX_WIDTH, SectionHeader, TWO_COLUMN_MAX_WIDTH, VideoPlayer, } from '../../ui';
import { ColorSetWrapper } from '../../ui/Colors/Colors';
const SEG_1_IMAGE_COLUMNS_12_COL = '1 / 3';
const SEG_1_TEXT_COLUMNS_12_COL = '3 / 7';
const SEG_2_IMAGE_COLUMNS_12_COL = '7/9';
const SEG_2_TEXT_COLUMNS_12_COL = '9/13';
const SEG_1_IMAGE_COLUMNS_2_COL = '1 / 1';
const SEG_1_TEXT_COLUMNS_2_COL = '1/1';
const SEG_2_IMAGE_COLUMNS_2_COL = '2/2';
const SEG_2_TEXT_COLUMNS_2_COL = '2/2';
const Wrapper = styled(Grid) `
  color: ${cssColorValue('textBase')};
  background: ${cssColorValue('backgroundBase')};
  padding-top: ${({ heroMedia }) => (heroMedia ? spacer48 : spacer56)};
  padding-bottom: ${({ heroMedia }) => (heroMedia ? spacer48 : spacer56)};
  @media (max-width: 1439px) {
    padding-top: ${({ heroMedia }) => (heroMedia ? spacer40 : spacer48)};
    padding-bottom: ${({ heroMedia }) => (heroMedia ? spacer40 : spacer48)};
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-bottom: ${spacer48};
  }
  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    padding-top: ${({ heroMedia }) => (heroMedia ? spacer24 : spacer40)};
  }
`;
const ImageContainer = styled(ImageAspectBox21x9) `
  grid-column: 1 / -1;
  margin-bottom: ${spacer32};
`;
const VideoContainer = styled.div `
  grid-column: 1 / -1;
  margin-bottom: ${spacer32};
  overflow: hidden;
`;
const SectionHeaderWrapper = styled.div `
  grid-column: 1/9;
  padding-bottom: ${spacer48};
  @media (max-width: ${screenMdMax}) {
    grid-column: 1 / 11;
    padding-bottom: ${spacer40};
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
  }
`;
const SegmentImageWrapper = styled.div `
  grid-column: ${({ first }) => first ? SEG_1_IMAGE_COLUMNS_12_COL : SEG_2_IMAGE_COLUMNS_12_COL};
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: ${({ first }) => first ? SEG_1_IMAGE_COLUMNS_2_COL : SEG_2_IMAGE_COLUMNS_2_COL};
    grid-row: ${({ heroMedia }) => (heroMedia ? 3 : 2)};
    .media {
      height: 336px;
      width: 189px;
    }
  }
  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
    grid-row: unset;
    justify-content: center;
    display: flex;
    .media {
      height: 464px;
      width: 261px;
    }
  }
`;
const SegmentTextWrapper = styled.div `
  grid-column: ${({ first }) => first ? SEG_1_TEXT_COLUMNS_12_COL : SEG_2_TEXT_COLUMNS_12_COL};
  margin-inline-start: ${spacer16};
  margin-inline-end: ${spacer72};
  @media (max-width: ${screenMdMax}) {
    margin-inline-start: unset;
    margin-inline-end: ${spacer40};
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-top: ${spacer24};
    grid-column: ${({ first }) => first ? SEG_1_TEXT_COLUMNS_2_COL : SEG_2_TEXT_COLUMNS_2_COL};
  }

  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    margin-inline-start: unset;
    margin-inline-end: unset;
    grid-column: 1 / -1;
    text-align: center;
    padding-bottom: ${({ first }) => (first ? spacer56 : 'unset')};
  }
`;
export const TwoUpModule = React.forwardRef(({ supertext = '', headline = '', image, video, caption = '', segment1Headline = '', segment1Body = '', segment1LinkText = '', segment1LinkUrl = '', segment1LinkOpenNewTab = false, segment1Image, segment1Video, segment2Headline = '', segment2Body = '', segment2LinkText = '', segment2LinkUrl = '', segment2LinkOpenNewTab = false, segment2Image, segment2Video, themeName, colors, }, ref) => {
    var _a, _b, _c, _d, _e;
    const segment1 = {
        segmentHeadline: segment1Headline,
        segmentBody: segment1Body,
        segmentLinkText: segment1LinkText,
        segmentLinkUrl: segment1LinkUrl,
        segmentLinkOpenNewTab: segment1LinkOpenNewTab,
        segmentImage: segment1Image,
        segmentVideo: segment1Video,
    };
    const segment2 = {
        segmentHeadline: segment2Headline,
        segmentBody: segment2Body,
        segmentLinkText: segment2LinkText,
        segmentLinkUrl: segment2LinkUrl,
        segmentLinkOpenNewTab: segment2LinkOpenNewTab,
        segmentImage: segment2Image,
        segmentVideo: segment2Video,
    };
    const useColors = (colors === null || colors === void 0 ? void 0 : colors.backgroundColor) && colors.textColor;
    const videoProps = {
        ...video,
        ...{ playOnHover: false, playButtonOnLoad: true },
    };
    const heroMedia = ((_b = (_a = video === null || video === void 0 ? void 0 : video.video) === null || _a === void 0 ? void 0 : _a.muxData) === null || _b === void 0 ? void 0 : _b.playbackId) || ((_c = image === null || image === void 0 ? void 0 : image.file) === null || _c === void 0 ? void 0 : _c.url) ? true : false;
    const forcePlayOnHover = ((_d = segment1.segmentVideo) === null || _d === void 0 ? void 0 : _d.video.muxData) &&
        ((_e = segment2.segmentVideo) === null || _e === void 0 ? void 0 : _e.video.muxData)
        ? true
        : false;
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(ColorSetWrapper, { colors: colors },
            React.createElement("div", { ref: ref },
                React.createElement(Wrapper, { className: !useColors
                        ? makeColorSetClass(themeName === 'whiteOnBlack' ? 'invertedDark' : 'base')
                        : '', heroMedia: heroMedia },
                    video && (React.createElement(VideoContainer, null,
                        React.createElement(VideoPlayer, { ...videoProps }))),
                    !video && image && (React.createElement(ImageContainer, null,
                        React.createElement(ContentfulImage, { asset: image, caption: caption }))),
                    headline && (React.createElement(SectionHeaderWrapper, null,
                        React.createElement(SectionHeader, { heading: headline, eyebrow: supertext }))),
                    React.createElement(SegmentImageWrapper, { first: true, heroMedia: heroMedia },
                        React.createElement(TwoUpSegmentMedia, { className: "media", ...segment1, forcePlayOnHover: forcePlayOnHover })),
                    React.createElement(SegmentTextWrapper, { first: true },
                        React.createElement(TwoUpSegmentText, { ...segment1 })),
                    React.createElement(SegmentImageWrapper, { heroMedia: heroMedia },
                        React.createElement(TwoUpSegmentMedia, { className: "media", ...segment2, forcePlayOnHover: forcePlayOnHover })),
                    React.createElement(SegmentTextWrapper, null,
                        React.createElement(TwoUpSegmentText, { ...segment2 })))))));
});
